<div class="primeng-multiselect-wrapper">
  <!-- Selected Items Display -->
  <div
    class="selected-items-container"
    [ngClass]="{
      'single-mode': isSingle,
      'multi-mode': !isSingle,
    }"
    *ngIf="getSelectedItems().length > 0"
    [title]="getHoverTooltip()"
  >
    <!-- Single Selection Display -->
    <div class="single-selection-display" *ngIf="isSingle && getSelectedItems().length > 0">
      <span
        class="single-selected-label clickable-remove"
        [title]="'Click to remove: ' + getSelectedItems()[0].label"
        (click)="removeSelectedItem(getSelectedItems()[0])"
        (mousedown)="$event.stopPropagation()"
      >
        {{ getSelectedItems()[0].label }}
      </span>
    </div>

    <!-- Multi Selection Display -->
    <div *ngIf="!isSingle">
      <div class="selection-count-indicator" *ngIf="getSelectedItems().length > 3">
        {{ getSelectedItems().length }}
      </div>

      <div
        class="selected-item-chip clickable-remove"
        *ngFor="let item of getSelectedItems(); trackBy: trackByValue"
        [ngClass]="{ 'loading-chip': item.label.startsWith('Loading...') }"
        [title]="'Click to remove: ' + item.label"
        [attr.aria-label]="'Click to remove: ' + item.label"
        (click)="removeSelectedItem(item)"
        (mousedown)="$event.stopPropagation()"
      >
        <span class="chip-label">
          {{ getTruncatedLabel(item.label) }}
          <i class="pi pi-spinner pi-spin" *ngIf="item.label.startsWith('Loading...')"></i>
        </span>
      </div>
    </div>
  </div>

  <!-- AutoComplete Input -->
  <p-autoComplete
    #autoComplete
    [suggestions]="filteredOptions"
    [dropdown]="useExistingDataOnly"
    [showClear]="getSelectedItems().length > 0"
    [multiple]="false"
    [completeOnFocus]="true"
    [forceSelection]="false"
    [formControl]="searchControl"
    (completeMethod)="search($event)"
    (onSelect)="onSelect($event)"
    (onClear)="onClear()"
    (onFocus)="onFocus()"
    (onBlur)="onBlur()"
    (onKeyUp)="onKeyUp($event)"
    field="label"
    [style]="{ width: '100%' }"
    [inputStyle]="{ width: '100%' }"
    appendTo="body"
    [delay]="useExistingDataOnly ? 0 : 300"
    [minLength]="useExistingDataOnly ? 0 : 2"
    [emptyMessage]="getEmptyMessage()"
    [title]="getInputTooltip()"
  >
  </p-autoComplete>
</div>
